import { render, staticRenderFns } from "./workerForm.vue?vue&type=template&id=225fba4a&scoped=true&"
import script from "./workerForm.vue?vue&type=script&lang=js&"
export * from "./workerForm.vue?vue&type=script&lang=js&"
import style0 from "./workerForm.vue?vue&type=style&index=0&id=225fba4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fba4a",
  null
  
)

export default component.exports